import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import SnackbarCookies from './SnackbarCookies';

let moment = require('moment');
require("moment/min/locales.min");

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex"
	},

	FooterCntr: {
		marginTop: 70
	},

	footer: {
		fontSize: '16px',
		lineHeight: '34px',
		color: '#8987A2',
		padding: '34px 0'

	},

	footer1: {
		fontSize: '14.5px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '34px 0px 64px 0px'
	},

	LinkType: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',
		borderBottom: '1px solid #8987A2',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},

	LinkType2: {
		marginLeft: 16,
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',
		borderBottom: '1px solid #8987A2',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},
}));

export default function Footer(props) {
	const classes = useStyles();
	const language = localStorage.getItem('language') || 'Ru'
	const IsRu = language === 'Ru'
	moment.locale(`${language.toLowerCase()}`);

	return (
		<Grid container id='FooterCntr' className={classes.FooterCntr}>
			<Grid xs={12} style={{ marginBottom: '32px' }}>
				<Divider />
			</Grid>

			<Grid item lg={12} md={12} sm={12} style={{ padding: 0, marginTop: 8 }}>
				<a href="/about" className={classes.LinkType}>{IsRu ? 'О компании' : 'About us'}</a>
				<a href="/contacts" className={classes.LinkType2}>{IsRu ? 'Контакты' : 'Contacts'}</a>
				<a href="https://www.cft.ru/sites/cft/Documents/Politics.pdf" target="blank" className={classes.LinkType2}>{IsRu ? "Политика в области обработки персональных данных" : "Personal Data Processing Policy"}</a>
				<span className={classes.LinkType2} onClick={() => props._altCookieSnackbar(true)} style={{ cursor: 'pointer' }}>{IsRu ? "Настройки конфиденциальности" : "Privacy settings"}</span>
			</Grid>

			<Grid item lg={12} md={12} sm={12} style={{ padding: 0 }}>
				<Typography className={classes.footer}>
					{IsRu ? '© Все права защищены, АО «ЦФТ» (АО «Центр Финансовых Технологий»)' : '© All rights reserved, CFT JSC (Center of Financial Technologies JSC)'}, {new Date().getFullYear()}
				</Typography>
			</Grid>

			{
				IsRu
					?
					<Grid item lg={12} md={12} sm={12} style={{ padding: '0 0 34px' }} className={classes.footer1}>
						Акционерное общество «Центр Финансовых Технологий»  (АО «ЦФТ») <br />
						Юридический адрес: 630559, Новосибирская область, Новосибирский район, р.п. Кольцово, дом 35<br />
						Почтовый адрес:  630055, г. Новосибирск, ул. Шатурская, д. 2<br />
						ОГРН: 1025403199689, ИНН: 5407125059, КПП: 543301001
					</Grid>
					:
					<Grid item lg={12} md={12} sm={12} style={{ padding: '0 0 34px' }} className={classes.footer1}>
						"Center of Financial Technologies" joint-stock company ("CFT" JSC)  <br />
						Legal address: 35 Koltsovo settlement, Novosibirsk district, Novosibirsk oblast, 630559<br />
						Mailing address: 2 Shaturskaya street, Novosibirsk, 630055<br />
						OGRN: 1025403199689, TIN: 5407125059, KPP: 543301001
					</Grid>
			}
		</Grid>
	);
}
